import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MessageCircle, ArrowRight } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF, WHATSAPP_HREF } from '../data/constants';
type ContactCTAProps = {
  /** Titre de la bande d'appel à l'action */
  title?: string;
  /** Phrase d'accroche sous le titre */
  subtitle?: string;
  /** Lien secondaire optionnel (candidater, recruter…) */
  action?: {
    label: string;
    to: string;
  };
  /** Variante visuelle : fond violet foncé ou fond clair */
  variant?: 'dark' | 'light';
  className?: string;
};
export function ContactCTA({
  title = 'Une question ? Parlons-en directement',
  subtitle = 'Notre équipe vous répond du lundi au vendredi. Appelez-nous ou écrivez-nous sur WhatsApp, la réponse est rapide.',
  action,
  variant = 'dark',
  className = ''
}: ContactCTAProps) {
  const isDark = variant === 'dark';
  return <section className={`${isDark ? 'bg-primary-dark' : 'bg-lavande'} rounded-3xl p-8 md:p-12 relative overflow-hidden ${className}`} data-id="element-335" data-mp="3363pkm2xrgey">
      <div className="h-1.5 w-full bg-brand-orange absolute top-0 left-0" data-id="element-336" data-mp="g7ub0e87ya5g" />

      <div className="relative z-10 flex flex-col lg:flex-row lg:items-center gap-8" data-id="element-337" data-mp="l5vrqsi69xdr">
        <div className="lg:flex-1" data-id="element-338" data-mp="p9v6b5jw6m4h">
          <h2 className={`text-2xl md:text-3xl font-extrabold font-heading mb-3 ${isDark ? 'text-white' : 'text-primary-dark'}`} data-id="element-339" data-mp="p9lh3k6o8izu">
            {title}
          </h2>
          <p className={`leading-relaxed ${isDark ? 'text-lavande' : 'text-primary-dark/80'}`} data-id="element-340" data-mp="3tl74lpnihscv">
            {subtitle}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 shrink-0" data-id="element-341" data-mp="6ghfncn7p1uo">
          <a href={PHONE_HREF} className="flex items-center justify-center gap-3 bg-brand-orange hover:bg-[#E67E22] text-white font-bold rounded-2xl px-6 py-4 transition-colors shadow-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-342" data-mp="balo60c4lhxv">
            <Phone className="w-5 h-5 shrink-0" data-id="element-343" data-mp="m2cdyh9c5z29" />
            <span className="text-left leading-tight" data-id="element-344" data-mp="h4kb4s75ksja">
              <span className="block text-xs font-medium uppercase tracking-wider opacity-90" data-id="element-345" data-mp="h414w8qv7sl3">
                Appelez-nous
              </span>
              <span className="text-lg" data-id="element-346" data-mp="quccq6do6lx9">{PHONE_DISPLAY}</span>
            </span>
          </a>

          <a href={WHATSAPP_HREF} target="_blank" rel="noopener noreferrer" className={`flex items-center justify-center gap-3 font-bold rounded-2xl px-6 py-4 transition-colors shadow-lg focus:outline-none focus-visible:ring-2 ${isDark ? 'bg-white hover:bg-lavande text-primary-dark focus-visible:ring-white' : 'bg-primary-dark hover:bg-primary text-white focus-visible:ring-primary-dark'}`} data-id="element-347" data-mp="34rqnem7z8jr">
            <MessageCircle className="w-5 h-5 shrink-0" data-id="element-348" data-mp="1ils2g9aiworp" />
            <span className="text-left leading-tight" data-id="element-349" data-mp="1ila2b1kqpqei">
              <span className="block text-xs font-medium uppercase tracking-wider opacity-70" data-id="element-350" data-mp="1r2am1vbhwjwh">
                Réponse rapide
              </span>
              <span className="text-lg" data-id="element-351" data-mp="1v218jmtzodv7">Écrivez-nous sur WhatsApp</span>
            </span>
          </a>
        </div>
      </div>

      {action && <div className={`relative z-10 mt-8 pt-6 border-t ${isDark ? 'border-white/15' : 'border-primary-dark/15'}`} data-id="element-352" data-mp="1m2nyot1ydn9y">
          <Link to={action.to} className={`group inline-flex items-center gap-2 font-bold underline underline-offset-4 transition-colors ${isDark ? 'text-lavande hover:text-white' : 'text-primary hover:text-brand-orange'}`} data-id="element-353" data-mp="29ve92xu7jyi4">
            {action.label}
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-354" data-mp="2squutp6we23i" />
          </Link>
        </div>}
    </section>;
}